import PayoneerActive from './payoneer-active';

export default PayoneerActive;
